export default "__VITE_ASSET__Dls84v0n__"